export const getSelectedManegerLabel = (managerOpts, managerId) => {
    let curSelect = managerOpts.filter(option => {
        return option.value === managerId;
    });

    return curSelect[0]?.label;
};

export const getSelectedDayLabel = (dayOptions, day) => {
    let curSelect = dayOptions.filter(option => {
        return option.value === day;
    });

    return curSelect[0]?.label;
};
